class SamplePacksContract {
    constructor() {
        this.abi = [
	{
		"constant": false,
		"inputs": [
			{
				"name": "ipfsHash",
				"type": "bytes32"
			}
		],
		"name": "newSamplePack",
		"outputs": [
			{
				"name": "",
				"type": "uint32"
			}
		],
		"payable": false,
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"name": "",
				"type": "address"
			},
			{
				"indexed": true,
				"name": "",
				"type": "uint32"
			}
		],
		"name": "NewSamplePack",
		"type": "event"
	},
	{
		"constant": false,
		"inputs": [
			{
				"name": "ipfsHash",
				"type": "bytes32"
			},
			{
				"name": "tags",
				"type": "bytes32[4]"
			}
		],
		"name": "newSamplePackWithTags",
		"outputs": [
			{
				"name": "",
				"type": "uint32"
			}
		],
		"payable": false,
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"name": "",
				"type": "uint32"
			},
			{
				"indexed": true,
				"name": "",
				"type": "bytes32"
			}
		],
		"name": "SamplePackTagged",
		"type": "event"
	},
	{
		"constant": false,
		"inputs": [
			{
				"name": "id",
				"type": "uint32"
			},
			{
				"name": "tags",
				"type": "bytes32[4]"
			}
		],
		"name": "tagSamplePack",
		"outputs": [],
		"payable": false,
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [],
		"payable": false,
		"stateMutability": "nonpayable",
		"type": "constructor"
	},
	{
		"constant": false,
		"inputs": [
			{
				"name": "id",
				"type": "uint32"
			},
			{
				"name": "ipfsHash",
				"type": "bytes32"
			}
		],
		"name": "updateSamplePackSamples",
		"outputs": [],
		"payable": false,
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"constant": true,
		"inputs": [],
		"name": "getNumberOfSamplePacks",
		"outputs": [
			{
				"name": "",
				"type": "uint32"
			}
		],
		"payable": false,
		"stateMutability": "view",
		"type": "function"
	},
	{
		"constant": true,
		"inputs": [
			{
				"name": "id",
				"type": "uint32"
			}
		],
		"name": "getSamplePackIpfsHash",
		"outputs": [
			{
				"name": "",
				"type": "bytes32"
			}
		],
		"payable": false,
		"stateMutability": "view",
		"type": "function"
	}
        ];
        this.contractAddress = '0x1f4d647863b75171b40680f269d4c8cbf3ed50b7';
    }
}

export default SamplePacksContract;
